export default __webpack_public_path__ + "static/media/icon-partners.20235948.svg";